import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Agent } from 'src/app/interfaces/agent.interface';
import { IProfanityDetails, Violation } from 'src/app/interfaces/Violation.interface';
import { AppConfig } from 'src/app/services/app.config.services';
import { TrsEventsService } from 'src/app/services/trsevents.service';
import { AuditService } from '../../../../services/audit.service';
import { AgentListInfo } from 'src/app/services/agent.list.info';
import { TranslocoService } from '@ngneat/transloco';
import { WebRTCService } from 'src/app/services/webrtc.service';
import { SupervisorService, Widgets } from 'src/app/services/supervisor.service';

@Component({
  selector: 'app-voilation-history',
  templateUrl: './voilation-history.component.html',
  styleUrls: ['./voilation-history.component.sass'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class VoilationHistoryComponent implements OnInit {
  date = new Date();
  violationHistory: any;
  events: any[];
  @Input() AgentLanId: string;
  @Input() AgentProfilePic: string;

  loadedViolationCount = 0;
  showPopUp: boolean = false;
  enableEscalate: boolean = false;
  appConfig = AppConfig.settings;
  violationIndexId: number;
  noMoreViolationsToLoad = false;
  ChatEvents = AppConfig.settings.ChatEvents;
  hoverId: string;
  maximized = false;
  @Input() supervisorCanViewMedia: boolean;
  loading = true;
  filteredEvents: any = [];
  loadingEvents = false;
  eventHistoryLoadingComplete = false;
  @Input() violationsPerPage: number;
  @ViewChild('scrollViolations') public scrollViolations: ElementRef<any>;

  timerCount = 0;
  collapsed = false;

  showEventFilter = false;
  loadingEventsForAgentId: string;

  selectedAgentInternal: string = "";
  showSecureAssistPopup: boolean = false;

  screenSelectionPopupVisibility: boolean = false;
  screenshareAgentLanId: string = "";

  screenGlancePopupVisibility: boolean = false;

  eventHistoryLabel: string = "";
  filterByEventsLabel: string = "";
  minimizeLabel: string = "";
  maximizeLabel: string = "";
  noDataFoundLabel: string = "";
  loadingLabel: string = "";
  blackOutTokenLabel: string = "";
  eventIdLabel: string = "";
  loadPreviousViolationsLabel: string = "";

  constructor(private trsService: TrsEventsService, private toastService: ToastrService,
    private auditService: AuditService, private agentListInfoService: AgentListInfo, private translationService: TranslocoService,
    public webrtcInfoService: WebRTCService, private supervisorService: SupervisorService) {
    this.eventHistoryLabel = this.translationService.translate("Event History");
    this.filterByEventsLabel = this.translationService.translate("Filter By events");
    this.minimizeLabel = this.translationService.translate("Minimize");
    this.maximizeLabel = this.translationService.translate("Maximize");
    this.noDataFoundLabel = this.translationService.translate("No Data Found");
    this.loadingLabel = this.translationService.translate("Loading");
    this.blackOutTokenLabel = this.translationService.translate("Black Out Token");
    this.eventIdLabel = this.translationService.translate("Event Id");
    this.loadPreviousViolationsLabel = this.translationService.translate("Load Previous Violations");
  }

  ngOnInit(): void {
    if (this.trsService.events[this.trsService.selectedAgentId]) {
      this.events = this.trsService.events[this.trsService.selectedAgentId];
      this.loadedViolationCount = this.events.length;
      this.loading = false;
      this.scroll();
    }

    this.supervisorService.maximizedWidget$.subscribe((widget: Widgets) => {
      if (widget === 'EventHistory')
        this.maximized = true;
      else this.maximized = false;
    })

    this.trsService.evtDataObservable.subscribe(response => {
      switch (response.eventName) {
        case "LOADNEXTVIOLATIONS": this.OnLoadMoreViolations(); break;
        case "CUSTOM_VIOLATION_EVENT": this.handleViolation(response.data); break;
        case "AGENT_CHANGED":
        case "SELECTED_AGENT": this.selectedAgent(); break;
        case "FILTER_EVENT_BY_NAME": this.filterEventByName(response.data); break;
        case "SHOW_SCREEN_DEVICE_SELECTION_POPUP":
          this.showScreenSelectionPopup(response.data);
          break;
        case "HIDE_SCREEN_DEVICE_SELECTION_POPUP":
          this.hideScreenSelectionPopup();
          break;
      }
    });
  }

  OnLoadMoreViolations() {
    this.loadingEvents = false;
    this.noMoreViolationsToLoad = true;
    this.loading = false;
    if (this.trsService.events[this.trsService.selectedAgentId] == null) {
      this.events = [];
      this.loadedViolationCount = 0;
      this.loading = false;
      return;
    }
    this.events = this.trsService.events[this.trsService.selectedAgentId];
    this.loadedViolationCount = Object.keys(this.events).length;
    this.setEventHistoryLoadingStatus();

    if (this.filteredEvents.length > 0) {
      this.filterEventByName(this.filteredEvents);
    }

    if (Object.keys(this.events).length > 0)
      this.scroll();
  }

  handleViolation(violation: Violation) {
    if (this.trsService.selectedAgentId != violation.AgentLanId) {
      return;
    }
    if (this.ChatEvents.includes(violation.ViolationName)) {
      return;
    }
    violation.Show = true;
    if (this.trsService.events[violation.AgentLanId] == null) {
      this.trsService.events[violation.AgentLanId] = [];
    }
    this.events = this.trsService.events[violation.AgentLanId];

    if (this.filteredEvents.length) {
      if (this.filteredEvents.includes(violation.ViolationName)) {
        violation.Show = true;
      }
      else {
        violation.Show = false;
      }
    }
    else {
      violation.Show = true;
    }
    this.timerCount = 0;
    this.scroll();
  }

  selectedAgent = () => {
    if (this.selectedAgentInternal !== this.trsService.selectedAgentId) {
      this.selectedAgentInternal = this.trsService.selectedAgentId;
      this.noMoreViolationsToLoad = true;

      if (this.trsService.events[this.trsService.selectedAgentId] != null) {
        this.events = this.trsService.events[this.trsService.selectedAgentId];
        this.loadedViolationCount = Object.keys(this.events).length;
      }
      else {
        this.events = [];
        this.loadedViolationCount = 0;
      }

      this.timerCount = 0;
      this.loading = false;
      this.setEventHistoryLoadingStatus();
      this.scroll();
    }
  }

  filterEventByName = (data: any): void => {
    if (this.filteredEvents.length === 0 && data.length === 0)
      return;

    this.filteredEvents = data;

    if (this.events == null || this.events.length === 0)
      return;

    this.events.forEach((violation: { EventId: number, ViolationName: string; Show: boolean }) => {
      if (this.filteredEvents.length > 0) {
        if ((this.filteredEvents.includes(violation.ViolationName) === true || this.filteredEvents.includes(violation.EventId.toString()) === true) && this.appConfig.ChatEvents.includes(violation.ViolationName) === false)
          violation.Show = true;
        else violation.Show = false;
      }
      else {
        if (this.appConfig.ChatEvents.includes(violation.ViolationName) === false)
          violation.Show = true;
        else violation.Show = false;
      }
    });
  }

  loadNextViolationsRequest() {
    this.loadingEvents = true;
    this.loadingEventsForAgentId = this.AgentLanId;
    let data = {
      agentLanId: this.trsService.selectedAgentId,
      recordCount: this.loadedViolationCount,
      pageSize: this.violationsPerPage,
    };

    this.sendEvent("loadNextViolationsData", data);
  }

  toggleFilter() {
    this.showEventFilter = !this.showEventFilter;
    this.sendEvent("SELECTED_EVENT_FILTER", this.showEventFilter);
  }

  toggleMaximize = (): void => this.supervisorService.ToggleLastMaximizedWidget('EventHistory');

  toggleCollapse() {
    this.collapsed = !this.collapsed;
  }

  scroll() {
    try {
      let interval = setInterval(() => {
        this.timerCount += 1;
        if (this.timerCount === 1) {
          this.scrollViolations.nativeElement.scrollLeft += this.scrollViolations.nativeElement.scrollWidth;
          this.scrollViolations.nativeElement.scrollTo(
            {
              left: this.scrollViolations.nativeElement.scrollWidth,
              behavior: 'smooth'
            });
        }
      }, 1000);

      setTimeout(function () {
        clearInterval(interval);
      }, 4000) // stop it after 10seconds
    } catch (err) { }
  }

  setHoverId(id: string) {
    this.hoverId = id;
  }

  unSetHoverId() {
    this.hoverId = "";
  }

  copyText(val: string) {
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.toastService.success("Copied to clipboard");
  }

  sendEvent(eventName: any, responseData: any) {
    let data = {
      "eventName": eventName,
      "data": responseData
    };
    this.trsService.evtdata.next(data);
  }

  hideViolationDetailsPopUp = (): void => {
    if (this.events[this.violationIndexId] != null && this.events[this.violationIndexId].Category != null && this.events[this.violationIndexId].Category === "SA")
      this.showSecureAssistPopup = false;
    else this.showPopUp = false;
  }

  showViolationDetailsPopUp = (violationIndex: number): void => {
    if (this.events[violationIndex] != null && this.events[violationIndex].Category == null) {
      if (!this.supervisorCanViewMedia) {
        return;
      }

      if (this.appConfig.Escalate.enabled && this.appConfig.Escalate.violations.includes(this.events[violationIndex].ViolationName)) {
        //If hierarchy is empty that means there is no one above the user and no can approve even if they escalate the request
        if (this.trsService.Hierarchy != null && this.trsService.Hierarchy.length > 0)
          this.enableEscalate = true;
        else this.enableEscalate = false;
      }
      else this.enableEscalate = false;
    }
    else this.enableEscalate = false;

    this.violationIndexId = violationIndex;

    if (this.events[violationIndex] != null && this.events[violationIndex].Category != null && this.events[violationIndex].Category === "SA") {
      this.showSecureAssistPopup = true;

      const eventDetails: Violation = this.events[violationIndex];

      if (eventDetails.ProfanityDetails != null && eventDetails.ProfanityDetails.length > 0) {
        let subsessionIds: string[] = [];
        eventDetails.ProfanityDetails.forEach((info: IProfanityDetails) => {
          if (info.SubSessionId != null && info.SubSessionId !== "")
            subsessionIds.push(info.SubSessionId);
        });

        if (subsessionIds.length > 0) {
          this.sendEvent("REFRESHMEDIAURL_REQUEST", {
            "AgentLanId": eventDetails.AgentLanId,
            "EventId": "",
            "ViolationId": eventDetails.ViolationId,
            "supervisorId": this.trsService.supervisorId,
            "SubSessionIds": subsessionIds,
          });
        }
      }
    }
    else if (this.events[violationIndex] != null && this.events[violationIndex].ViolationName != null && this.events[violationIndex].ViolationName !== "" && this.events[violationIndex].ViolationName.includes("Screen Glance") === true)
      this.screenGlancePopupVisibility = true;
    else this.showPopUp = true;

    this.auditService.AuditSupervisorUsage(9, this.AgentLanId, this.events[violationIndex].EventId);
  }

  setEventHistoryLoadingStatus = (): void => {
    const agentInfo: Agent | null = this.agentListInfoService.GetAgentInfo(this.trsService.selectedAgentId);

    if (agentInfo != null) {
      this.eventHistoryLoadingComplete = agentInfo.IsViolationHistoryLoadingComplete;
    }
  }

  showScreenSelectionPopup = (lanId: string): void => {
    if (lanId != null && lanId !== "") {
      this.hideViolationDetailsPopUp();
      this.screenSelectionPopupVisibility = true;
      this.screenshareAgentLanId = lanId;
    }
  }

  hideScreenSelectionPopup = (): void => {
    this.screenSelectionPopupVisibility = false;
  }

  hideScreenGlanceDetailsPopup = (): void => {
    this.screenGlancePopupVisibility = false;
  }
}
